import { NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from './shared/shared.module';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AdminComponent } from './admin/admin.component';
import { EmployeeManagementComponent } from './employee-management/employee-management.component';
import { ProductsComponent } from './products/products.component';
import { ProductDetailsComponent } from './product-details/product-details.component';
import { CustomerVisitsComponent } from './customer-visits/customer-visits.component';
import { EmployeeDetailsComponent } from './employee-details/employee-details.component';
import { CustomerDetailsComponent } from './customer-details/customer-details.component';
import { EditProductComponent } from './edit-product/edit-product.component';
import { EditEmloyeeComponent } from './edit-emloyee/edit-emloyee.component';
import { CustomerVisitDetailsComponent } from './customer-visit-details/customer-visit-details.component';
import { CustomersComponent } from './customers/customers.component';
import { InvoicesComponent } from './invoices/invoices.component';
import { InvoiceDetailsComponent } from './invoice-details/invoice-details.component';
import { ReceiptsComponent } from './receipts/receipts.component';
import { ReceiptsDetailsComponent } from './receipts-details/receipts-details.component';
import { EditCustomerComponent } from './edit-customer/edit-customer.component';
import { ProductCompliantComponent } from './product-compliant/product-compliant.component';
import { CustomerCompliantComponent } from './customer-compliant/customer-compliant.component';
import { UserDetailComponent } from './user-detail/user-detail.component';
import { CreateUserComponent } from './create-user/create-user.component';
import { BrandsComponent } from './brands/brands.component';
import { BrandDetailComponent } from './brand-detail/brand-detail.component';
import { EditBrandComponent } from './edit-brand/edit-brand.component';
import { SingleUserDetailComponent } from './single-user-detail/single-user-detail.component';
import { UserprivilegeComponent } from './userprivilege/userprivilege.component';
import { LeadsComponent } from './leads/leads.component';
import { EditLeadsComponent } from './edit-leads/edit-leads.component';
import { CreateLeadComponent } from './create-lead/create-lead.component';
import { EditUserComponent } from './edit-user/edit-user.component';
import { SaleOrdersComponent } from './sale-orders/sale-orders.component';
import { CreateOrderComponent } from './create-order/create-order.component';
import { SaleOrderDetailsComponent } from './sale-order-details/sale-order-details.component';
import { ProductAdviceComponent } from './product-advice/product-advice.component';
import { ProductAdviceViewComponent } from './product-advice-view/product-advice-view.component';
import { FolderComponent } from './folder/folder.component';
import { MachineComponent } from './machine/machine.component';
import { EditFolderComponent } from './edit-folder/edit-folder.component';
import { CustomerApprovalComponent } from './customer-approval/customer-approval.component';
import { SalesPojectionComponent } from './sales-pojection/sales-pojection.component';
import { ProductionsComponent } from './productions/productions.component';
import { ProductionDetailsComponent } from './production-details/production-details.component';
import { ProductStockComponent } from './product-stock/product-stock.component';
import { StockDetailComponent } from './stock-detail/stock-detail.component';
import { DepartmentComponent } from './department/department.component';
// import { AddWorkingDaysComponent } from './add-working-days/add-working-days.component';
// import { DepartmentWsViewComponent } from './department-ws-view/department-ws-view.component';
// import { DepartmentWsEditComponent } from './department-ws-edit/department-ws-edit.component';
import { SalesTeamComponent } from './sales-team/sales-team.component';
import { SalesTeamCreationComponent } from './sales-team-creation/sales-team-creation.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { SalesTeamViewComponent } from './sales-team-view/sales-team-view.component';
import { SalesTeamEditComponent } from './sales-team-edit/sales-team-edit.component';
import { EditDepartmentComponent } from './edit-department/edit-department.component';
import { DepartmentDetailComponent } from './department-detail/department-detail.component';
import { EmployeeAttendenceComponent } from './employee-attendence/employee-attendence.component';
import { KycComponent } from './kyc/kyc.component';
// import { CrmComponent } from './crm/crm.component';
// import { RFRComponent } from './crm/rfr/rfr.component';
import { EmployeeKpiComponent } from './employee-kpi/employee-kpi.component';
import { MarketingVisitComponent } from './marketing-visit/marketing-visit.component';
import { MarketStudyComponent } from './market-study/market-study.component';

import { AttendanceRequestComponent } from './attendance-request/attendance-request.component';
import { UserWorkingdaysComponent } from './user-workingdays/user-workingdays.component';
import { UserWorkingdaysListComponent } from './user-workingdays-list/user-workingdays-list.component';
import { UserWorkingdaysEditComponent } from './user-workingdays-edit/user-workingdays-edit.component';
import { UserWorkingdaysViewComponent } from './user-workingdays-view/user-workingdays-view.component';
import { MarketSyudyComponent } from './market-syudy/market-syudy.component';
import { MarketStudyJebelaliComponent } from './market-study-jebelali/market-study-jebelali.component';
import { EmployeeKpiEditComponent } from './employee-kpi-edit/employee-kpi-edit.component';
import { AlqousbmMarketStudyComponent } from './alqousbm-market-study/alqousbm-market-study.component';
import { NepalMarketStudyComponent } from './nepal-market-study/nepal-market-study.component';
import { NepalautomativeMarketStudyComponent } from './nepalautomative-market-study/nepalautomative-market-study.component';

import { KpiRequestRevertListComponent } from './kpi-request-revert-list/kpi-request-revert-list.component';
import { SidepannelComponent } from './admin/sidepannel/sidepannel.component';
import { NavbarComponent } from './admin/navbar/navbar.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FactoryProjectionComponent } from './factory-projection/factory-projection.component';
import { FactoryProjectionListingComponent } from './factory-projection-listing/factory-projection-listing.component';
import { FactoryProjectionCreateComponent } from './factory-projection-create/factory-projection-create.component';
import { MarketingCampaignComponent } from './marketing-campaign/marketing-campaign.component';
import { QatarMarketStudyComponent } from './qatar-market-study/qatar-market-study.component';
import { FactoryMenuComponent } from './factory-menu/factory-menu.component';
import { EmployeeKpiDetailsComponent } from './employee-kpi-details/employee-kpi-details.component';
import { WarehouseComponent } from './warehouse/warehouse.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoginInterceptorInterceptor } from './Auth/login-interceptor.interceptor';
import { AuthenticationGuard } from './Auth/authentication.guard';
import { AttendanceRequestEditComponent } from './attendance-request-edit/attendance-request-edit.component';
import { EmployeeAttendenceDetailsComponent } from './employee-attendence/employee-attendence-details/employee-attendence-details.component';
import { SummaryReportComponent } from './external-page/summary-report/summary-report.component';
import { MarketStudyInsideComponent } from './market-study-inside/market-study-inside.component';
import { MarketStudyDecorativeComponent } from './market-study-decorative/market-study-decorative.component';
import { MarketStudyOthersComponent } from './market-study-others/market-study-others.component';
import { EmployeeAttendanceBetaComponent } from './employee-attendance-beta/employee-attendance-beta.component';
import { EmployeeAttendanceBetaDetailsComponent } from './employee-attendance-beta/employee-attendance-beta-details/employee-attendance-beta-details.component';
import { ShiftAssignmentComponent } from './employee-attendance-beta/shift-assignment-master/shift-assignment/shift-assignment.component';
import { DepartmentListComponent } from './employee-attendance-beta/shift-assignment-master/department-list/department-list.component';
import { DepartmentEditPageComponent } from './department-edit-page/department-edit-page.component';
import { WebPunchingComponent } from './web-punching/web-punching.component';
import { CustomerSurveyComponent } from './factory-customer-survey/customer-survey/customer-survey.component';
import { CustomerSurveyListingComponent } from './factory-customer-survey/customer-survey-listing/customer-survey-listing.component';
import { CustomerSurveyDetailComponent } from './factory-customer-survey/customer-survey-detail/customer-survey-detail.component';
import { CustomerSurveyEditComponent } from './factory-customer-survey/customer-survey-edit/customer-survey-edit.component';
import { CustomerSurveyAssignmentComponent } from './factory-customer-survey/assignment/assignment.component';
import { QuestionCreationComponent } from './factory-customer-survey/question-creation/question-creation.component';
import { FeedbackComponent } from './factory-customer-survey/feedback/feedback.component';
import { FeedbackDetailComponent } from './factory-customer-survey/feedback-detail/feedback-detail.component';
import { QuestionListingComponent } from './factory-customer-survey/question-listing/question-listing.component';
import { QuestionDetailComponent } from './factory-customer-survey/question-detail/question-detail.component';
import { QuestionEditComponent } from './factory-customer-survey/question-edit/question-edit.component';
import { AssignmentListingComponent } from './factory-customer-survey/assignment-listing/assignment-listing.component';
import { AssignmentDetailComponent } from './factory-customer-survey/assignment-detail/assignment-detail.component';
import { FeedbackIntakeComponent } from './factory-customer-survey/feedback-intake/feedback-intake.component';
import { FeedbackUpdateComponent } from './factory-customer-survey/feedback-update/feedback-update.component';
import { KpiMonthlyReportsComponent } from './kpi-monthly-report/kpi-monthly-reports/kpi-monthly-reports.component';
import { MasterForRfrListingComponent } from './master-for-rfr/master-for-rfr-listing/master-for-rfr-listing.component';
import { MasterForRfrEditComponent } from './master-for-rfr/master-for-rfr-edit/master-for-rfr-edit.component';
import { ViewLeaveRequestComponent } from './Leave-Request/view-leave-request/view-leave-request.component';
import { EditLeaveRequestComponent } from './Leave-Request/edit-leave-request/edit-leave-request.component';
import { DetailLeaveRequestComponent } from './Leave-Request/detail-leave-request/detail-leave-request.component';
import { MixingSecondComponent } from './mixing-ii/mixing-ii/mixing-ii.component';
import { CreateTempUserComponent } from './user-detail/create-temp-user/create-temp-user.component';
import { DepartmentMasterEditComponent } from './department-master/department-master-edit/department-master-edit.component';
import { DepartmentMasterListingComponent } from './department-master/department-master-listing/department-master-listing.component';
import { ExcludedRfrUsersListingComponent } from './excluded-rfr-users-master/excluded-rfr-users-listing/excluded-rfr-users-listing.component';
import { ExcludedRfrUsersEditComponent } from './excluded-rfr-users-master/excluded-rfr-users-edit/excluded-rfr-users-edit.component';
import { AiAssistantComponent } from './ai-assistant/ai-assistant.component';
import { AiChatPageComponent } from './ai-assistant/ai-chat-page/ai-chat-page.component';
import { VisitMapDirective } from './ai-assistant/visit-map.directive';
import { NgxEchartsModule } from 'ngx-echarts';
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    AdminComponent,
    EmployeeManagementComponent,
    ProductsComponent,
    ProductDetailsComponent,
    CustomerVisitsComponent,
    EmployeeDetailsComponent,
    CustomerDetailsComponent,
    EditProductComponent,
    EditEmloyeeComponent,
    CustomerVisitDetailsComponent,
    CustomersComponent,
    InvoicesComponent,
    InvoiceDetailsComponent,
    ReceiptsComponent,
    ReceiptsDetailsComponent,
    EditCustomerComponent,
    ProductCompliantComponent,
    CustomerCompliantComponent,
    UserDetailComponent,
    CreateUserComponent,
    BrandsComponent,
    BrandDetailComponent,
    EditBrandComponent,
    SingleUserDetailComponent,
    UserprivilegeComponent,
    LeadsComponent,
    EditLeadsComponent,
    CreateLeadComponent,
    EditUserComponent,
    SaleOrdersComponent,
    CreateOrderComponent,
    SaleOrderDetailsComponent,
    ProductAdviceComponent,
    ProductAdviceViewComponent,
    FolderComponent,
    MachineComponent,
    EditFolderComponent,
    CustomerApprovalComponent,
    SalesPojectionComponent,
    ProductionsComponent,
    ProductionDetailsComponent,
    ProductStockComponent,
    StockDetailComponent,
    DepartmentComponent,
    // DepartmentWsViewComponent,
    // DepartmentWsEditComponent,
    SalesTeamComponent,
    SalesTeamCreationComponent,
    SalesTeamViewComponent,
    SalesTeamEditComponent,
    EditDepartmentComponent,
    DepartmentDetailComponent,
    EmployeeAttendenceComponent,
    KycComponent,
    // CrmComponent,
    // RFRComponent,
    EmployeeKpiComponent,
    MarketingVisitComponent,
    MarketStudyComponent,
    AttendanceRequestComponent,
    UserWorkingdaysComponent,
    UserWorkingdaysListComponent,
    UserWorkingdaysEditComponent,
    UserWorkingdaysViewComponent,
    MarketSyudyComponent,
    MarketStudyJebelaliComponent,
    EmployeeKpiEditComponent,
    AlqousbmMarketStudyComponent,
    NepalMarketStudyComponent,
    NepalautomativeMarketStudyComponent,
    KpiRequestRevertListComponent,
    SidepannelComponent,
    NavbarComponent,
    DashboardComponent,
    FactoryProjectionComponent,
    FactoryProjectionListingComponent,
    FactoryProjectionCreateComponent,
    MarketingCampaignComponent,
    QatarMarketStudyComponent,
    FactoryMenuComponent,
    EmployeeKpiDetailsComponent,
    WarehouseComponent,
    AttendanceRequestEditComponent,
    EmployeeAttendenceDetailsComponent,
    SummaryReportComponent,
    MarketStudyInsideComponent,
    MarketStudyDecorativeComponent,
    MarketStudyOthersComponent,
    EmployeeAttendanceBetaComponent,
    EmployeeAttendanceBetaDetailsComponent,
    ShiftAssignmentComponent,
    DepartmentListComponent,
    DepartmentEditPageComponent,
    WebPunchingComponent,
    CustomerSurveyComponent,
    CustomerSurveyDetailComponent,
    CustomerSurveyEditComponent,
    CustomerSurveyListingComponent,
    CustomerSurveyAssignmentComponent,
    QuestionCreationComponent,
    FeedbackComponent,
    FeedbackDetailComponent,
    QuestionListingComponent,
    QuestionDetailComponent,
    QuestionEditComponent,
    AssignmentListingComponent,
    AssignmentDetailComponent,
    FeedbackIntakeComponent,
    FeedbackUpdateComponent,
    KpiMonthlyReportsComponent,
    MasterForRfrListingComponent,
    MasterForRfrEditComponent,
    ViewLeaveRequestComponent,
    EditLeaveRequestComponent,
    DetailLeaveRequestComponent,
    CreateTempUserComponent,
    DepartmentMasterEditComponent,
    DepartmentMasterListingComponent,
    ExcludedRfrUsersListingComponent,
    ExcludedRfrUsersEditComponent,
    AiAssistantComponent,
    AiChatPageComponent,
    VisitMapDirective,
    // MixingSecondComponent,
  ],
  imports: [
    NgMultiSelectDropDownModule.forRoot(),
    BrowserModule,
    SharedModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NgSelectModule,
    NgxEchartsModule.forRoot({ echarts: () => import('echarts') }),

  ],
  providers: [
    {
      provide:HTTP_INTERCEPTORS,
      useClass:LoginInterceptorInterceptor,
      multi:true
    },
    AuthenticationGuard
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}